import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { Select } from "shared/ui/input/select/select/Select"

import { formatProjectPosition } from "entities/projects/lib/formatProjectPosition"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export type RoomPositionInputProps = WithClassName

export const RoomPositionInput = React.memo(
  ({ className }: RoomPositionInputProps) => {
    const { t } = useTranslation()
    const {
      isReadonly,
      isDisabled,
      positionOptions,
      isLoadingPositionOptions
    } = useRoomFormContext()

    return (
      <Select.Root
        name="displayPosition"
        label={t("ProjectChild.Position")}
        className={classNames("room-form__position", className)}
        readonly={isReadonly}
        disabled={isDisabled}
        loading={isLoadingPositionOptions}
        data-testid="room__position__select"
      >
        <Select.Label />
        <Select.Input options={positionOptions} />
        <Select.Readonly
          render={value =>
            typeof value === "number" ? formatProjectPosition([value]) : "-"
          }
        />
        <Select.ErrorMessage />
      </Select.Root>
    )
  }
)
